class EnvironmentMIQ {
    static get init(): IEnvironmentMIQ {
        const env = window.environment || 'local';
        return this.environmentsOm[env];
    }

    static environmentsOm: { [key: string]: IEnvironmentMIQ } = {
        local: {
            production: false,
            pdauthURL: 'https://pddvgisweb.penndot.pa.gov:8443/PDAUTH',
            internalURLBase: 'https://pddvgisweb.penndot.pa.gov',
            externalURLBase: 'https://pddvgisweb.penndot.pa.gov',
            arcserverURL: 'https://gis.penndot.pa.gov/gis',
            personalRecordEditorConfigs: [
                {
                    layerId: 6973,
                    userField: "CWOPA",
                    userFieldType: "email"
                }
            ],
            titleAddition: ' - Local'
        },
        dev: {
            production: false,
            pdauthURL: 'https://pddvgisweb.penndot.pa.gov:8443/PDAUTH',
            internalURLBase: 'https://pddvgisweb.penndot.pa.gov',
            externalURLBase: 'https://pddvgisweb.penndot.pa.gov',
            arcserverURL: 'https://gis.penndot.pa.gov/gis',
            personalRecordEditorConfigs: [
                {
                    layerId: 6973,
                    userField: "CWOPA",
                    userFieldType: "email"
                }
            ],
            titleAddition: ' - Development'
        },
        test: {
            production: true,
            pdauthURL: window.location.origin + '/PDAUTH',
            internalURLBase: 'https://pdstgisweb.penndot.pa.gov',
            externalURLBase: 'https://gistest.penndot.pa.gov',
            arcserverURL: 'https://gis.penndot.pa.gov/gis',
            personalRecordEditorConfigs: [
                {
                    layerId: 6973,
                    userField: "CWOPA",
                    userFieldType: "email"
                }
            ],
            titleAddition: ' - System Test'
        },
        prod: {
            production: true,
            pdauthURL: window.location.origin + '/PDAUTH',
            internalURLBase: 'https://pdprgisweb.penndot.pa.gov',
            externalURLBase: 'https://gis.penndot.pa.gov',
            arcserverURL: 'https://gis.penndot.pa.gov/gis',
            personalRecordEditorConfigs: [
                {
                    layerId: 6973,
                    userField: "CWOPA",
                    userFieldType: "email"
                }
            ]
        }
    };

    static getBaseUrl() {
        return window.location.origin + (window.location.pathname.indexOf('/', 1) > -1 ? window.location.pathname.slice(0, window.location.pathname.indexOf('/', 1) + 1) : window.location.pathname);
    }
}

interface IEnvironmentMIQ {
    production: boolean;
    pdauthURL: string;
    arcserverURL: string;
    internalURLBase: string;
    externalURLBase: string;
    titleAddition?: string;
    personalRecordEditorConfigs: {
        layerId: number;
        userField: string;
        userFieldType: string;
    }[];
}

export const environmentMIQ = EnvironmentMIQ.init;
